import api from '../../../../App/socket';

export const getCapDerivatives = variant_id => api.send({
    api: 'module',
    module: 'Leads',
    classMethod: 'GetCapData',
    options: {
        method: 'getDerivatives',
        params: {
            variant_id,
        },
    },
}).then(response => response).catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/cap_requests/get_cap_derivatives_request.js